import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import ErrorLabel from 'automation-ui-core/components/ErrorLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MissingLabel = ({
  type,
  internalName
}) => {
  const typeLangKey = `missingLabel.${type}`;
  const internalNameLangKey = `missingLabel.withInternalName.${type}`;
  return /*#__PURE__*/_jsxs(ErrorLabel, {
    children: [isValidI18nKey(typeLangKey) ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: typeLangKey
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "missingLabel.default"
    }), internalName && isValidI18nKey(internalNameLangKey) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
        message: internalNameLangKey,
        options: {
          internalName
        }
      })]
    })]
  });
};
MissingLabel.propTypes = {
  type: PropTypes.string.isRequired,
  internalName: PropTypes.string
};
export default MissingLabel;